import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-business-type-wise-product-discount-edit-dialog',
  templateUrl: './business-type-wise-product-discount-edit-dialog.component.html',
  styleUrls: ['./business-type-wise-product-discount-edit-dialog.component.scss']
})
export class BusinessTypeWiseProductDiscountEditDialogComponent {
  discount_price: any = null;

  constructor(
    public dialogRef: MatDialogRef<BusinessTypeWiseProductDiscountEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.discount_price = data['discount_price'];
  }

  updateCalled(discount_price) {
    if (this.data['update_for'] == 'by_product') {
      this.updateDiscountPriceForByProduct(discount_price);
    } else {
      this.updateDiscountPrice(discount_price);
    }
  }

  updateDiscountPrice(discount_price) {
    const discount_price_data = {
      product_id: this.data['product_id'],
      business_type_id: this.data['business_type_id'],
      discount_price: this.discount_price,
    };
    this.http.saveOrUpdateBusinessTypeWiseProductDiscountPrice(discount_price_data).subscribe((res_data) => {
      console.log(res_data);
      this.global.showSnakeBar('Discount price updated successfully!');
      this.closeComponent(discount_price_data);
    }, (error) => {
      console.log(error);
    });
  }

  updateDiscountPriceForByProduct(discount_price) {
    const discount_price_data = {
      product_id: this.data['product_id'],
      business_type_id: this.data['business_type_id'],
      discount_price: this.discount_price,
    };
    this.http.saveOrUpdateBusinessTypeWiseProductDiscountPriceForByProduct(discount_price_data).subscribe((res_data) => {
      console.log(res_data);
      this.global.showSnakeBar('Discount price updated successfully!');
      this.closeComponent(discount_price_data);
    }, (error) => {
      console.log(error);
    });
  }

  removeCalled() {
    if (this.data['update_for'] == 'by_product') {
      this.removeCalledForByProduct();
    } else {
      this.removeCalledForProduct();
    }
  }

  removeCalledForProduct() {
    if (confirm('Are you sure to remove this product')) {
      const discount_price_data = {
       product_id: this.data['product_id'],
       business_type_id: this.data['business_type_id'],
       discount_price: this.discount_price,
     };
     console.log(discount_price_data);
     this.http.removeBusinessTypeWiseProductDiscountPrice(discount_price_data).subscribe((res_data) => {
       console.log(res_data);
       this.global.showSnakeBar('Discount price updated successfully!');
       this.closeComponent(discount_price_data);
     }, (error) => {
       console.log(error);
     });
    }
  }

  removeCalledForByProduct() {
    if (confirm('Are you sure to remove this product')) {
      const discount_price_data = {
       product_id: this.data['product_id'],
       business_type_id: this.data['business_type_id'],
       discount_price: this.discount_price,
     };
     console.log(discount_price_data);
     this.http.removeBusinessTypeWiseProductPriceForByProduct(discount_price_data).subscribe((res_data) => {
       console.log(res_data);
       this.global.showSnakeBar('Discount price updated successfully!');
       this.closeComponent(discount_price_data);
     }, (error) => {
       console.log(error);
     });
    }
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }
}

interface DialogData {
  product_id: number;
  business_type_id: number;
  business_type_name: string;
  discount_price: number;
}
